export default __webpack_public_path__ + "static/media/e14.17b1311d.jpg";